import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Tick",
  "use": "Tick-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" role=\"img\" viewBox=\"0 0 20 20\" id=\"Tick\">\n\t<path d=\"M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM9 15l-4-4 1.41-1.41L9 12.17l5.59-5.59L16 8l-7 7z\" fill=\"#008FBE\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol